import { config, library } from "@fortawesome/fontawesome-svg-core"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope, faUniversity } from "@fortawesome/free-solid-svg-icons"

// Prevent duplicate style injection and ensure all used icons are in the global library.
config.autoAddCss = false
library.add(fab, faEnvelope, faUniversity)
